import { v4 as uuid } from 'uuid';

const TAB_KEY = 'referral-tab-id-v1';
let currentTabId;

/** Discard copied referral records using an identity independent of the current link. */
export default function initializeReferralTab() {
  const storedId = window.sessionStorage.getItem(TAB_KEY);
  if (storedId && storedId === currentTabId) return;

  let openerId;
  try {
    openerId = window.opener?.sessionStorage.getItem(TAB_KEY);
  } catch {
    // A cross-origin opener cannot share its tab identity.
  }

  const inherited = storedId && storedId === openerId;
  if (inherited) {
    Object.keys(window.sessionStorage).forEach((key) => {
      if (key === 'referral-context-v1' || key.startsWith('referral-coupon-handoff-v1:')) {
        window.sessionStorage.removeItem(key);
      }
    });
  }

  const tabId = inherited || !storedId ? uuid() : storedId;
  window.sessionStorage.setItem(TAB_KEY, tabId);
  currentTabId = tabId;
}
